import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CONSENT_KEY = "onevo_cookie_consent";

export const getConsent = () => localStorage.getItem(CONSENT_KEY); // "accepted" | "rejected" | null

const setConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(new Event("onevo-cookie-change"));
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 flex justify-center">
      <div className="w-full max-w-[1100px] bg-[#111112] border border-white/15 rounded-xl shadow-2xl p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex items-start gap-4 flex-1">
          <Cookie size={26} className="text-white/80 mt-0.5 shrink-0" strokeWidth={1.5} />
          <p className="text-white/70 text-sm leading-relaxed">
            Utilizziamo cookie tecnici necessari al funzionamento del sito e, previo tuo consenso,
            cookie di terze parti (es. Google Maps) per migliorare la tua esperienza. Puoi accettare
            o rifiutare. Maggiori dettagli nella{" "}
            <Link to="/privacy" className="text-white underline underline-offset-2 hover:text-white/80">
              Privacy &amp; Cookie Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={() => choose("rejected")}
            className="font-mono-label text-[11px] text-white border border-white/25 px-6 py-3.5 rounded-md hover:bg-white/5 transition-colors"
          >
            Rifiuta
          </button>
          <button
            onClick={() => choose("accepted")}
            className="font-mono-label text-[11px] bg-white text-black px-6 py-3.5 rounded-md hover:bg-white/85 transition-colors"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
